TrelloModel = require 'models/internal/trello-model'

module.exports = class NotificationGroup extends TrelloModel
  typeName: 'NotificationGroup'
  urlRoot: '/1/notificationGroups'



// WEBPACK FOOTER //
// ./app/scripts/models/notification-group.coffee